$(function () {

    function padTwoDigits(num) {
        return num.toString().padStart(2, "0");
    }

    function dateInYyyyMmDdHhMm(date, dateDiveder = "-") {

        return (
            [
                date.getFullYear(),
                padTwoDigits(date.getMonth() + 1),
                padTwoDigits(date.getDate()),
            ].join(dateDiveder) +
            " " +
            [
                padTwoDigits(date.getHours()),
                padTwoDigits(date.getMinutes()),
            ].join(":")
        );
    }

    function loadEventDetail(url) {
        $.when($.ajax({
            type: 'POST',
            url: url,
            async: false,
            cache: true,
            success: function (data) {
                if (data.status === 'success') {
                    if ($('#eventModal').length != 0) {
                        $('#eventModalLabel').html(data.data.title);
                        $('#eventModalContent').html(data.data.content);
                        $('#event_approve_button').hide();
                        $('#event_decline_button').hide();
                        if (data.data.isOwner) {
                            $('#event_update_button').show();
                            $('#event_delete_button').show();
                        } else {
                            $('#event_update_button').hide();
                            $('#event_delete_button').hide();
                        }
                        if (data.data.approved == 0) {
                            $('#event_approve_button').show();
                            $('#event_decline_button').show();
                        }
                    } else {
                        $('.fc-goToCalendarButton-button').click();
                    }
                } else {
                    $('#eventModalLabel').html('Chyba');
                    $('#eventModalContent').html('Chyba při načítání detailu události');
                }
            },
            error: function (data) {
                bootbox.alert('Nepodařilo se načíst detail události');
            }, dataType: 'json'
        })).done(function (result) {
            return result;
        });
        $('#eventModal').modal('show');
    }

    $(document).ready(function () {
        if ($('#calendar').length > 0) {
            console.log('Initialize calendar');
            const Selectors = {
                ACTIVE: '.active',
                ADD_EVENT_FORM: '#addEventForm',
                ADD_EVENT_MODAL: '#addEventModal',
                CALENDAR: '#appCalendar',
                CALENDAR_TITLE: '.calendar-title',
                CALENDAR_DAY: '.calendar-day',
                CALENDAR_DATE: '.calendar-date',
                DATA_CALENDAR_VIEW: '[data-fc-view]',
                DATA_EVENT: 'data-event',
                DATA_VIEW_TITLE: '[data-view-title]',
                EVENT_DETAILS_MODAL: '#eventDetailsModal',
                EVENT_DETAILS_MODAL_CONTENT: '#eventDetailsModal .modal-content',
                EVENT_START_DATE: '#addEventModal [name="Calendar[event_start]"]',
                INPUT_TITLE: '[name="title"]'
            };

            var calendarEl = document.getElementById('calendar');

            // FullCalendar otherwise derives the view height from aspectRatio
            // (width / 1.35). On mobile the width is small, so the resulting
            // height collapses to ~270px and the grid looks cramped. Give it a
            // usable, viewport-based height and keep it in sync on resize.
            function getCalendarHeight() {
                if (window.innerWidth < 768) {
                    return Math.max(window.innerHeight - 180, 500);
                }
                return 'auto';
            }

            // Zapamatovat si naposledy zvolené zobrazení (měsíc/týden/den/agenda),
            // aby po refreshi stránky zůstalo místo výchozího měsíce. Ukládáme do
            // sessionStorage (per-záložka), aby to nekolidovalo s jiným stránkami.
            var CALENDAR_VIEW_STORAGE_KEY = 'calendar.lastView';
            var CALENDAR_DATE_STORAGE_KEY = 'calendar.lastDate';
            var ALLOWED_VIEWS = ['dayGridMonth', 'timeGridWeek', 'timeGridDay', 'listWeek'];
            var savedView = null;
            var savedDate = null;
            try {
                savedView = sessionStorage.getItem(CALENDAR_VIEW_STORAGE_KEY);
                savedDate = sessionStorage.getItem(CALENDAR_DATE_STORAGE_KEY);
            } catch (e) {
                savedView = null;
                savedDate = null;
            }
            if (ALLOWED_VIEWS.indexOf(savedView) === -1) {
                savedView = 'dayGridMonth';
            }
            // Platné je jen datum ve formátu YYYY-MM-DD, jinak necháme výchozí (dnes).
            if (!savedDate || !/^\d{4}-\d{2}-\d{2}$/.test(savedDate)) {
                savedDate = null;
            }

            // Týdenní zobrazení: výchozí pracovní doba 06:00–18:00, ale rozsah se
            // automaticky rozšíří, pokud v zobrazeném týdnu existuje událost mimo ni
            // (aby se nikdy žádná událost neschovala). Ostatní zobrazení = celých 24 h.
            var WORK_SLOT_MIN_MINUTES = 6 * 60;   // 06:00
            var WORK_SLOT_MAX_MINUTES = 18 * 60;  // 18:00
            // Uživatelské přepnutí týdenního zobrazení na celých 24 h (kvůli zakládání
            // událostí do skrytých hodin). Drží se po dobu session-navigace.
            var weekSlotExpanded = false;

            // Zobrazení s časovou mřížkou (týden/den), kde má smysl zužovat hodiny.
            function isTimeGridView() {
                return (typeof calendar !== 'undefined' && calendar.view
                    && (calendar.view.type === 'timeGridWeek' || calendar.view.type === 'timeGridDay'));
            }

            // Aktualizuje popisek/viditelnost tlačítka pro rozbalení hodin.
            function updateToggleHoursButton() {
                var $btn = $('.fc-toggleHours-button');
                if (!$btn.length) {
                    return;
                }
                $btn.toggle(isTimeGridView());
                $btn.html(weekSlotExpanded
                    ? '<i class="bi bi-arrows-collapse me-1"></i> Pracovní doba'
                    : '<i class="bi bi-arrows-expand me-1"></i> Celý den');
            }

            function minutesToSlot(mins) {
                if (mins >= 24 * 60) {
                    return '24:00:00';
                }
                return padTwoDigits(Math.floor(mins / 60)) + ':00:00';
            }

            function computeWeekSlotRange() {
                var minMinutes = WORK_SLOT_MIN_MINUTES;
                var maxMinutes = WORK_SLOT_MAX_MINUTES;
                var view = calendar.view;
                var rangeStart = view.activeStart;
                var rangeEnd = view.activeEnd;
                calendar.getEvents().forEach(function (ev) {
                    if (ev.allDay || !ev.start) {
                        return;
                    }
                    var s = ev.start;
                    var e = ev.end || ev.start;
                    // jen události zasahující do aktuálně zobrazeného týdne
                    if (e <= rangeStart || s >= rangeEnd) {
                        return;
                    }
                    var sm = s.getHours() * 60 + s.getMinutes();
                    var em = e.getHours() * 60 + e.getMinutes();
                    // událost končící až v jiném dni → počítáme do půlnoci
                    if (s.toDateString() !== e.toDateString() || em === 0) {
                        em = 24 * 60;
                    }
                    if (sm < minMinutes) {
                        minMinutes = sm;
                    }
                    if (em > maxMinutes) {
                        maxMinutes = em;
                    }
                });
                minMinutes = Math.floor(minMinutes / 60) * 60;
                maxMinutes = Math.ceil(maxMinutes / 60) * 60;
                if (maxMinutes > 24 * 60) {
                    maxMinutes = 24 * 60;
                }
                if (maxMinutes <= minMinutes) {
                    maxMinutes = minMinutes + 60;
                }
                return { min: minutesToSlot(minMinutes), max: minutesToSlot(maxMinutes) };
            }

            function syncWeekSlotRange() {
                if (typeof calendar === 'undefined' || !calendar.view) {
                    return;
                }
                var min = '00:00:00';
                var max = '24:00:00';
                if (isTimeGridView() && !weekSlotExpanded) {
                    var range = computeWeekSlotRange();
                    min = range.min;
                    max = range.max;
                }
                // setOption jen při reálné změně – zabrání zbytečnému překreslení / smyčce
                if (calendar.getOption('slotMinTime') !== min) {
                    calendar.setOption('slotMinTime', min);
                }
                if (calendar.getOption('slotMaxTime') !== max) {
                    calendar.setOption('slotMaxTime', max);
                }
            }

            var calendar = new FullCalendar.Calendar(calendarEl, {
                editable: true,
                selectable: true,
                businessHours: true,
                dayMaxEvents: true, // allow "more" link when too many events
                locale: 'cs',
                initialView: savedView,
                initialDate: savedDate || undefined,
                datesSet: function (info) {
                    // Uložit aktuální zobrazení i navigační datum při každé změně.
                    try {
                        sessionStorage.setItem(CALENDAR_VIEW_STORAGE_KEY, info.view.type);
                        // getDate() vrací kotevní datum kalendáře (ne první buňku
                        // rozsahu), takže se korektně obnoví i měsíc/týden.
                        var d = calendar.getDate();
                        var dateStr = d.getFullYear() + '-' + padTwoDigits(d.getMonth() + 1) + '-' + padTwoDigits(d.getDate());
                        sessionStorage.setItem(CALENDAR_DATE_STORAGE_KEY, dateStr);
                    } catch (e) {
                        // sessionStorage nedostupný (např. privátní režim) – ignorovat.
                    }
                    // Přepnout/zúžit rozsah hodin podle aktuálního zobrazení.
                    syncWeekSlotRange();
                    updateToggleHoursButton();
                },
                firstDay: 1,
                height: getCalendarHeight(),
                expandRows: true,
                scrollTime: '06:00:00',
                scrollTimeReset: false,
                windowResize: function () {
                    calendar.setOption('height', getCalendarHeight());
                },
                loading: function (isLoading) {
                    // When the async event source finishes loading it recomputes the
                    // time-grid height and resets the scroll to the top (00:00). Re-apply
                    // the 06:00 scroll on time-grid views once loading is done.
                    if (isLoading) {
                        return;
                    }
                    // Po načtení událostí přepočítat rozsah hodin (týden se rozšíří na reálné události).
                    syncWeekSlotRange();
                    var view = calendar.view;
                    if (view && view.type && view.type.indexOf('timeGrid') === 0) {
                        calendar.scrollToTime('06:00:00');
                    }
                },
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'toggleHours dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                },
                customButtons: {
                    toggleHours: {
                        text: 'Celý den',
                        click: function () {
                            weekSlotExpanded = !weekSlotExpanded;
                            updateToggleHoursButton();
                            syncWeekSlotRange();
                        }
                    }
                },
                buttonText: {
                    today: 'Dnes',
                    month: 'Měsíc',
                    week: 'Týden',
                    day: 'Den',
                    listWeek: 'Agenda',
                },
                eventSources: [
                    {
                        url: $('#calendar').data('events_url'),
                        method: 'POST',
                        format: 'json',
                        display: 'block',
                        failure: function () {
                            alert('there was an error while fetching events!');
                        }
                    }
                ],
                dateClick: function (info) {
                    $('#addEventModal').modal('show');
                    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
                    var d = info.date;
                    var dateStr = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
                    $('.event_start_date').val(dateStr).change();
                    $('.event_end_date').val(dateStr).change();
                    // In week/day (timeGrid) views a click carries the exact time, so
                    // prefill start/end time from it (end = start + 1h). In month view
                    // (info.allDay) there is no time, so keep the existing defaults.
                    if (!info.allDay) {
                        var startTime = pad(d.getHours()) + ':' + pad(d.getMinutes());
                        var endHour = (d.getHours() + 1) % 24;
                        var endTime = pad(endHour) + ':' + pad(d.getMinutes());
                        $('.event_start_time').val(startTime).change();
                        $('.event_end_time').val(endTime).change();
                    }
                },
                eventContent: function (arg) {
                    var title = arg.event.title;
                    if (arg.view.type.indexOf('list') === 0) {
                        return { html: title };
                    }
                    //month, week and day timegrid views
                    var timeHtml = arg.timeText ? '<div class="fc-event-time">' + arg.timeText + '</div>' : '';
                    return { html: timeHtml + '<div class="fc-event-title fc-sticky">' + title + '</div>' };
                },
                eventClick: function (calEvent, jsEvent, view) {
                    var url =
                        $('#calendar').data('event_detail_url') +
                        '?id=' +
                        calEvent.event.id +
                        '&start=' +
                        new Date(calEvent.event.start).toLocaleString('en-US') +
                        '&end=' +
                        new Date(calEvent.event.end).toLocaleString('en-US') +
                        '&virtual=' +
                        calEvent.event.extendedProps.isVirtual;
                    loadEventDetail(url);
                },
                editable: true,
                eventDrop: function (info) {
                    // Změna se uloží rovnou bez potvrzení; při chybě se vrátí zpět.
                    var url = $('#calendar').data('event_update_url');
                    var event_data = {
                        uuid: info.event.id,
                        start: new Date(info.oldEvent.start).toLocaleString('en-US'),
                        end: new Date(info.oldEvent.end).toLocaleString('en-US'),
                        virtual: info.oldEvent.extendedProps.isVirtual,
                        new_start: new Date(info.event.start).toLocaleString('en-US'),
                        new_end: new Date(info.event.end).toLocaleString('en-US')
                    };
                    $.ajax({
                        type: 'POST', url: url, async: false, dataType: 'json', data: event_data,
                        success: function (data) {
                            if (data.status == 'success') {
                                console.log(data);
                            } else {
                                info.revert();
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            info.revert();
                            bootbox.alert(data);
                        }
                    });
                },
                eventResize: function (info) {
                    // Změna se uloží rovnou bez potvrzení; při chybě se vrátí zpět.
                    var url = $('#calendar').data('event_update_url');
                    var event_data = {
                        uuid: info.event.id,
                        start: new Date(info.oldEvent.start).toLocaleString('en-US'),
                        end: new Date(info.oldEvent.end).toLocaleString('en-US'),
                        virtual: info.oldEvent.extendedProps.isVirtual,
                        new_start: new Date(info.event.start).toLocaleString('en-US'),
                        new_end: new Date(info.event.end).toLocaleString('en-US')
                    };
                    $.ajax({
                        type: 'POST', url: url, async: false, dataType: 'json', data: event_data,
                        success: function (data) {
                            if (data.status == 'success') {
                                console.log(data);
                            } else {
                                info.revert();
                                bootbox.alert(data.msg);
                            }
                        },
                        error: function (data) { // if error occured
                            info.revert();
                            bootbox.alert(data);
                        }
                    });
                }
            });
            calendar.render();
            calendarEl._fcApi = calendar;
            // Nastavit počáteční rozsah hodin podle výchozího zobrazení.
            syncWeekSlotRange();
            updateToggleHoursButton();
        }

        $(document).on('change', '.calendar_dates_fields', function (e) {
            $('#calendar-event_start').val($('.event_start_date').val() + ' ' + $('.event_start_time').val());
            $('#calendar-event_end').val($('.event_end_date').val() + ' ' + $('.event_end_time').val());
            $('.hr_sms_text_add').val($('#hr_default_sms_template_add').val().replace('{{hr_calendar_term}}', moment($('#calendar-event_start').val()).format('DD.MM.YYYY, HH:mm')));
        });

        $(document).on('change', '.calendar_dates_fields_upd', function (e) {
            $('.calendar_date_field_upd_start').val($('.event_start_date_upd').val() + ' ' + $('.event_start_time_upd').val());
            $('.calendar_date_field_upd_end').val($('.event_end_date_upd').val() + ' ' + $('.event_end_time_upd').val());
            $('.hr_sms_text_upd').val($('#hr_default_sms_template_update').val().replace('{{hr_calendar_term}}', moment($('.calendar_date_field_upd_start').val()).format('DD.MM.YYYY, HH:mm')));
        });

        $(document).on('click', '.show_event_detail_button', function (e) {
            var url = $(this).data('event_detail_url') + '?id=' + $(this).data('event_uuid');
            if ($(this).data('event_owner_uuid')) {
                url += '&owner_uuid=' + $(this).data('event_owner_uuid');
            }
            loadEventDetail(url);
        });

        $(document).on('click', '#candidate_add_event_button', function (e) {
            $('#addEventModal').modal('show');
            $('#candidate_event_uuid').val($(this).data('candidate_uuid'));
            $('#calendar-event_name').val('Pohovor');
        });

        $(document).on('click', '#create_event_submit_button', function (e) {
            e.preventDefault();
            var form = $(this).closest('form');
            var startDate = form.find('*[name="event_start_date"]').val();
            var startTime = form.find('*[name="event_start_time"]').val();
            var endDate = form.find('*[name="event_end_date"]').val();
            var endTime = form.find('*[name="event_end_time"]').val();
            if (startDate && startTime) {
                form.find('*[name="Calendar[event_start]"]').val(startDate + ' ' + startTime);
            }
            if (endDate && endTime) {
                form.find('*[name="Calendar[event_end]"]').val(endDate + ' ' + endTime);
            }
            var url = form.attr('action');
            var form_data = form.serialize();
            console.log(form_data);
            $.when($.ajax({
                type: 'POST',
                data: form_data,
                url: url,
                async: false,
                cache: true,
                dataType: 'json',
                success: function (data) {
                    if ($('#calendar').length != 0) {
                        calendar.refetchEvents();
                        $('#addEventModal').modal('hide');
                        $('#addEventModal form').trigger('reset');
                    } else {
                        document.location.reload();
                    }
                },
                error: function (data) {
                    bootbox.alert(data.responseJSON.msg);
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
            return true;
        });

        $(document).on('change', '#calendar-event_start', function (e) {
            var start_date = $(this).val();
            let d = new Date(start_date);
            var hour = d.getHours();
            var n = d.setHours(hour + 1);
            $('#calendar-event_end').val(dateInYyyyMmDdHhMm(new Date(n)));
        });

        $(document).on('click', '#event_update_button', function (e) {
            $('#eventModal').modal('hide');
            var url = $(this).data('url') +
                '?id=' + $('#detail_event_uuid').val() +
                '&start=' + new Date($('#detail_event_start').val()).toLocaleString('en-US') +
                '&end=' + new Date($('#detail_event_end').val()).toLocaleString('en-US') +
                '&virtual=' + $('#detail_event_virtual').val();
            $.when($.ajax({
                type: 'POST',
                url: url,
                async: false,
                cache: true,
                success: function (data) {
                    if (data.status === 'success') {
                        if ($('#eventUpdateModal').length != 0) {
                            $('#eventUpdateModalLabel').html(data.data.title);
                            $('#eventUpdateModalContent').html(data.data.content);
                            var participantChoice = $('#calendar-participants');
                            if (participantChoice.length > 0) {
                                let choices = new Choices(participantChoice[0], {
                                    removeItemButton: true,
                                    placeholder: true,
                                    loadingText: 'Načítání...',
                                    noResultsText: 'Nebyly nalezeny žádné výsledky',
                                    noChoicesText: 'Žádné možnosti na výběr',
                                    itemSelectText: 'Klikněte pro výběr',
                                    uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
                                });
                            }
                        } else {
                            $('.fc-goToCalendarButton-button').click();
                        }
                    } else {
                        $('#eventUpdateModalLabel').html('Chyba');
                        $('#eventUpdateModalContent').html('Chyba při načítání detailu události');
                    }
                },
                error: function (data) {
                    bootbox.alert('Nepodařilo se načíst detail události');
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
            $('#eventUpdateModal').modal('show');
        });

        $(document).on('click', '.event_button_list_approve', function (e) {
            var url = $(this).data('url');
            console.log(url);
            $.when($.ajax({
                type: 'POST',
                url: url,
                async: false,
                cache: true,
                success: function (data) {
                    console.log(data);
                    window.location.reload();
                },
                error: function (data) {
                    bootbox.alert('Nepodařilo se nastavit vaši účast');
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
        });

        $(document).on('click', '.notification_read', function (e) {
            var element = $(this);
            var notificationId = element.data('notification_id');
            console.log('Read notification id ' + notificationId);
            $.when($.ajax({
                type: 'GET',
                url: '/api/notification/set-read?id=' + notificationId,
                async: true,
                cache: false,
                success: function (data) {
                    console.log('Notifikace nastavena jako přečtená');
                },
                error: function (data) {
                    console.log('Nepodařilo se nastavit notifikaci jako přečtenou');
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
        });

        $(document).on('click', '.event_state_toggle_button', function (e) {
            var url = $(this).data('url');
            $.ajax({
                type: 'POST',
                url: url,
                dataType: 'json',
                success: function (data) {
                    if (data.status === 'success') {
                        $('#eventModal').modal('hide');
                        if ($('.reload-page-after-event-save').length > 0) {
                            window.location.reload();
                        } else if (typeof calendar !== 'undefined') {
                            calendar.refetchEvents();
                        }
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) {
                    bootbox.alert('Nepodařilo se změnit stav události');
                }
            });
        });

        $(document).on('click', '#event_approve_button', function (e) {
            var url = $(this).data('url') + '?id=' + $('#detail_event_uuid').val();
            var detail_url = $(this).data('detail_url') +
                '?id=' + $('#detail_event_uuid').val() +
                '&start=' + new Date($('#detail_event_start').val()).toLocaleString('en-US') +
                '&end=' + new Date($('#detail_event_end').val()).toLocaleString('en-US') +
                '&virtual=' + $('#detail_event_virtual').val();
            console.log(url);
            $.when($.ajax({
                type: 'POST',
                url: url,
                async: false,
                cache: true,
                success: function (data) {
                    console.log(data);
                    loadEventDetail(detail_url);
                },
                error: function (data) {
                    bootbox.alert('Nepodařilo se načíst detail události');
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
        });

        $(document).on('click', '#event_decline_button', function (e) {
            var url = $(this).data('url') + '?id=' + $('#detail_event_uuid').val();
            var detail_url = $(this).data('detail_url') +
                '?id=' + $('#detail_event_uuid').val() +
                '&start=' + new Date($('#detail_event_start').val()).toLocaleString('en-US') +
                '&end=' + new Date($('#detail_event_end').val()).toLocaleString('en-US') +
                '&virtual=' + $('#detail_event_virtual').val();
            console.log(url);
            $.when($.ajax({
                type: 'POST',
                url: url,
                async: false,
                cache: true,
                success: function (data) {
                    console.log(data);
                    loadEventDetail(detail_url);
                },
                error: function (data) {
                    bootbox.alert('Nepodařilo se načíst detail události');
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
        });

        $(document).on('click', '#event_update_save_button', function (e) {
            $('#eventUpdateModal').modal('hide');
            var form = $('#event_update_form');
            var uStartDate = $('.event_start_date_upd').val();
            var uStartTime = $('.event_start_time_upd').val();
            var uEndDate = $('.event_end_date_upd').val();
            var uEndTime = $('.event_end_time_upd').val();
            if (uStartDate && uStartTime) {
                $('.calendar_date_field_upd_start').val(uStartDate + ' ' + uStartTime);
            }
            if (uEndDate && uEndTime) {
                $('.calendar_date_field_upd_end').val(uEndDate + ' ' + uEndTime);
            }
            var url = form.attr('action');
            var form_data = form.serialize();
            console.log(url);

            if (url.endsWith('&virtual=1')) {
                bootbox.dialog({
                    title: 'Potvrzení',
                    message: 'Chcete upravit pouze tuto událost kalendáře?',
                    backdrop: true,
                    onEscape: true,
                    buttons: {
                        all: {
                            label: 'Celou řadu',
                            className: 'btn-primary',
                            callback: function () {
                                $.when($.ajax({
                                    type: 'POST',
                                    data: form_data,
                                    url: url + '&editMaster=1',
                                    async: false,
                                    cache: true,
                                    dataType: 'json',
                                    success: function (data) {
                                        if ($('.reload-page-after-event-save').length > 0) {
                                            console.log('reload');
                                            window.location.replace($('.reload-page-after-event-save').data('refresh_url'));
                                            window.location.reload();
                                            return true;
                                        } else {
                                            if (typeof calendar !== "undefined") {
                                                calendar.refetchEvents();
                                            }
                                        }
                                    },
                                    error: function (data) {
                                        bootbox.alert(data.msg);
                                    }, dataType: 'json'
                                })).done(function (result) {
                                    return result;
                                });
                            }
                        },
                        one: {
                            label: 'Pouze tato',
                            className: 'btn-success',
                            callback: function () {
                                $.when($.ajax({
                                    type: 'POST',
                                    data: form_data,
                                    url: url,
                                    async: false,
                                    cache: true,
                                    dataType: 'json',
                                    success: function (data) {
                                        if ($('.reload-page-after-event-save').length > 0) {
                                            console.log('reload');
                                            window.location.replace($('.reload-page-after-event-save').data('refresh_url'));
                                            window.location.reload();
                                            return true;
                                        } else {
                                            if (typeof calendar !== "undefined") {
                                                calendar.refetchEvents();
                                            }
                                        }
                                    },
                                    error: function (data) {
                                        bootbox.alert(data.msg);
                                    }, dataType: 'json'
                                })).done(function (result) {
                                    return result;
                                });
                            }
                        },
                        cancel: {
                            label: 'Zrušit',
                            className: 'btn-danger'
                        }
                    }
                });
            } else {
                $.when($.ajax({
                    type: 'POST',
                    data: form_data,
                    url: url,
                    async: false,
                    cache: true,
                    dataType: 'json',
                    success: function (data) {
                        if ($('.reload-page-after-event-save').length > 0) {
                            console.log('reload');
                            window.location.replace($('.reload-page-after-event-save').data('refresh_url'));
                            window.location.reload();
                            return true;
                        } else {
                            if (typeof calendar !== "undefined") {
                                calendar.refetchEvents();
                            }
                        }
                    },
                    error: function (data) {
                        bootbox.alert(data.msg);
                    }, dataType: 'json'
                })).done(function (result) {
                    return result;
                });
            }
        });

        $(document).on('click', '#event_delete_button', function (e) {
            var url = $(this).data('url') +
                '?id=' + $('#detail_event_uuid').val() +
                '&start=' + new Date($('#detail_event_start').val()).toLocaleString('en-US') +
                '&end=' + new Date($('#detail_event_end').val()).toLocaleString('en-US') +
                '&virtual=' + $('#detail_event_virtual').val();

            if ($('#detail_event_virtual').val() == 1) {
                bootbox.dialog({
                    title: 'Potvrzení',
                    message: 'Opravdu smazat událost z kalendáře?',
                    backdrop: true,
                    onEscape: true,
                    buttons: {
                        all: {
                            label: 'Celou řadu',
                            className: 'btn-primary',
                            callback: function () {
                                $.ajax({
                                    type: 'POST',
                                    url: url + '&removeMaster=1',
                                    async: false,
                                    dataType: 'json',
                                    success: function (data) {
                                        if (data.status == 'success') {
                                            $('#eventModal').modal('hide');
                                            if ($('.reload-page-after-event-save').length > 0) {
                                                console.log('reload');
                                                window.location.replace($('.reload-page-after-event-save').data('refresh_url'));
                                                window.location.reload();
                                                return true;
                                            } else {
                                                if (typeof calendar !== 'undefined') {
                                                    calendar.refetchEvents();
                                                }
                                            }
                                        } else {
                                            bootbox.alert(data.msg);
                                        }
                                    },
                                    error: function (data) {
                                        // if error occured
                                        bootbox.alert(
                                            'Chyba při provádění operace'
                                        );
                                    }
                                });
                                return true;
                            }
                        },
                        one: {
                            label: 'Pouze tato',
                            className: 'btn-success',
                            callback: function () {
                                $.ajax({
                                    type: 'POST',
                                    url: url,
                                    async: false,
                                    dataType: 'json',
                                    success: function (data) {
                                        if (data.status == 'success') {
                                            $('#eventModal').modal('hide');
                                            if ($('.reload-page-after-event-save').length > 0) {
                                                console.log('reload');
                                                window.location.replace($('.reload-page-after-event-save').data('refresh_url'));
                                                window.location.reload();
                                                return true;
                                            } else {
                                                if (typeof calendar !== 'undefined') {
                                                    calendar.refetchEvents();
                                                }
                                            }
                                        } else {
                                            bootbox.alert(data.msg);
                                        }
                                    },
                                    error: function (data) {
                                        // if error occured
                                        bootbox.alert(
                                            'Chyba při provádění operace'
                                        );
                                    }
                                });
                                return true;
                            }
                        },
                        cancel: {
                            label: 'Zrušit',
                            className: 'btn-danger'
                        }
                    }
                });
            } else {
                bootbox.confirm({
                    title: 'Potvrzení',
                    backdrop: true,
                    message: 'Opravdu smazat událost z kalendáře?',
                    buttons: {
                        confirm: { label: 'Ano', className: 'btn-success' },
                        cancel: { label: 'Ne', className: 'btn-danger' }
                    },
                    callback: function (result) {
                        if (result) {
                            $.ajax({
                                type: 'POST',
                                url: url,
                                async: false,
                                dataType: 'json',
                                success: function (data) {
                                    if (data.status == 'success') {
                                        $('#eventModal').modal('hide');
                                        if ($('.reload-page-after-event-save').length > 0) {
                                            console.log('reload');
                                            window.location.replace($('.reload-page-after-event-save').data('refresh_url'));
                                            window.location.reload();
                                            return true;
                                        } else {
                                            if (typeof calendar !== 'undefined') {
                                                calendar.refetchEvents();
                                            }
                                        }
                                    } else {
                                        bootbox.alert(data.msg);
                                    }
                                },
                                error: function (data) {
                                    // if error occured
                                    bootbox.alert(
                                        'Chyba při provádění operace'
                                    );
                                }
                            });
                            return true;
                        } else {
                            return true;
                        }
                    }
                });
            }
        });
    });

    $(document).on('change', '*[data-elid="select_worker_absence"]', function (e) {
        var worker_id = $(this).val();
        if (worker_id.length > 0) {
            var url = $(this).data('url') + '?id=' + worker_id;
            $.ajax({
                type: 'POST', url: url, async: false, dataType: 'json',
                success: function (data) {
                    if (data.status == 'success') {
                        console.log(data);
                        $('#calendar-event_name').val('Absence pracovníka - ' + data.data.name + ' ' + data.data.surname);
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) { // if error occured
                    bootbox.alert('Chyba při provádění operace');
                }
            });
        } else {
            $('#calendar-event_name').val('');
        }
    });

    $(document).on('change', '*[data-elid="select_absence_from"]', function (e) {
        $('#calendar-event_end').val($('*[data-elid="select_absence_from"]').val());
    });

    $(document).on('change', '#calendar-event_type', function (e) {
        console.log('Změna typu eventu');
        var type = $(this).val();
        console.log(type);
        if (type === 'hr') {
            $(this).closest('.modal-body').find('.hr_notification_section').show();
            $(this).closest('.modal-body').find('.hr_notification_section').find('input').prop('disabled', false);
            $(this).closest('.modal-body').find('.hr_notification_section').find('textarea').prop('disabled', false);
        } else {
            $(this).closest('.modal-body').find('.hr_notification_section').hide();
            $(this).closest('.modal-body').find('.hr_notification_section').find('input').prop('disabled', true);
            $(this).closest('.modal-body').find('.hr_notification_section').find('textarea').prop('disabled', true);
        }
    });

    $(document).on('change', 'input[name="Calendar[all_day]"]', function (e) {
        var element = $(this);
        console.log(element.is(':checked'));
        let start = element.closest('form').find('*[name="event_start_time"]');
        let end = element.closest('form').find('*[name="event_end_time"]');
        if (!start.length || !end.length) {
            return;
        }
        if (element.is(':checked')) {
            start.addClass('d-none');
            start.val('00:00');
            end.addClass('d-none');
            end.val('09:00');
        } else {
            start.removeClass('d-none');
            start.val('08:00');
            end.removeClass('d-none');
            end.val('09:00');
        }
    });

});
